import { MainContainer } from "../../styles/basicStyles";
import { DynamicPageType } from "../../models/dynamicPage";
import { useTranslation } from "next-i18next";
import { FC } from "react";
import Banner from "./components/banner";
import Metatags from "../../components/metatags";
import Content from "./components/content";

interface Props {
  data: DynamicPageType;
}

const DynamicPage: FC<Props> = ({ data }) => {
  const { i18n: { language } } = useTranslation();
  
  return (
    <>
      <Metatags
        title={data.meta_title && data.meta_title[language]}
        description={data.meta_description && data.meta_description[language]}
        keywords={data.meta_keywords && data.meta_keywords[language]}
        image={data.meta_image?.url}
      />
      <Banner title={data?.title && data?.title[language]} />
      <MainContainer>
        <Content description={data?.description && data?.description[language]} />
      </MainContainer>
    </>
  );
};

export default DynamicPage;
